import { create } from 'zustand';
import type { NotificationRecord } from '../types';

interface NotificationState {
  notifications: NotificationRecord[];
  unreadCount: number;
  setNotifications: (n: NotificationRecord[]) => void;
  setUnreadCount: (count: number) => void;
  addNotification: (n: NotificationRecord) => void;
  markRead: (id: string) => void;
  markAllRead: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  setNotifications: (notifications) => set({ notifications }),
  setUnreadCount: (unreadCount) => set({ unreadCount }),
  addNotification: (n) =>
    set((s) => ({
      notifications: [n, ...s.notifications],
      unreadCount: s.unreadCount + (n.read ? 0 : 1),
    })),
  markRead: (id) =>
    set((s) => {
      const n = s.notifications.find((n) => n.id === id);
      if (!n || n.read) return s;
      return {
        notifications: s.notifications.map((n) => (n.id === id ? { ...n, read: true } : n)),
        unreadCount: Math.max(0, s.unreadCount - 1),
      };
    }),
  markAllRead: () =>
    set((s) => ({
      notifications: s.notifications.map((n) => ({ ...n, read: true })),
      unreadCount: 0,
    })),
}));
